import Icon from "../icons";
import {useState} from "preact/hooks";
import Button from '../buttons'
import Subtitle from "../Subtitle";
import unescape from 'unescape';
import {useTranslations} from "../../contexts/TranslationsContext";

const Field = ({ children }) => (
    <div className="esc-ii-flex esc-ii-flex-col esc-ii-mt-5">{children}</div>
);

export const LabelWrapper = ({ children }) => (
    <div className="esc-ii-flex esc-ii-items-center esc-ii-mt-5 esc-ii-mb-3">
        {children}
    </div>
);

const Quantity = ({ label, onDecrement, onIncrement, qty, min, max }) => (
    <>
        <LabelWrapper>
            <Label>{label}</Label>
        </LabelWrapper>
        <div className="esc-ii-flex esc-ii-items-center">
            <div className="esc-ii-border esc-ii-border-secondary esc-ii-py-4 esc-ii-px-2 esc-ii-rounded">
                <button className="esc-ii-mr-2" onClick={onDecrement}>-</button>
                <input
                    isp_ignore
                    type="number"
                    className="esc-ii-opacity-100 esc-ii-text-black esc-ii-w-10 esc-ii-text-center esc-ii-bg-white"
                    style={`-webkit-text-fill-color: black`}
                    value={qty}
                    min={min}
                    max={max}
                    disabled
                />
                <button className="esc-ii-ml-2" onClick={onIncrement}>+</button>
            </div>
        </div>
    </>
);

export const Label = ({ children }) => (
    <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">{children}</h6>
);

/**
 * Renders one of the tooltips defined under `tooltips` in the translations context.
 *
 * `name` selects the entry. `title` overrides that entry's heading, for the one tooltip whose
 * heading follows a field label that changes with the data.
 */
export const Tooltip = ({ name, title }) => {
    const { tooltips } = useTranslations();
    const [active, setActive] = useState(false);

    const tooltip = tooltips[name] || {};
    // `t` HTML-escapes anything not suffixed `_html`, so apostrophes arrive as entities.
    const heading = unescape(title || tooltip.title || '', 'all');

    const Modal = ({ isActive }) => (
        <>
            <div className={`${active ? 'esc-ii-block' : 'esc-ii-hidden'} esc-ii-left-0 esc-ii-bottom-0 esc-ii-fixed esc-ii-w-full esc-ii-h-full esc-ii-bg-black esc-ii-opacity-20 esc-ii-z-50`}></div>
            <div style={{ display: isActive ? 'flex' : 'none', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}
                 className={`esc-ii-flex-col esc-ii-fixed esc-ii-bg-white esc-ii-z-50 esc-ii-w-[calc(100%-40px)] esc-ii-pb-3 lg:esc-ii-w-full lg:esc-ii-max-w-[725px]`}>
                <div className="esc-ii-flex esc-ii-justify-end esc-ii-items-center esc-ii-pt-3 esc-ii-px-3 esc-ii-pb-1 lg:esc-ii-pt-7 lg:esc-ii-px-7">
                    <Button.Close onClick={() => {
                        setActive(false);
                    }} />
                </div>
                <div className="esc-ii-flex esc-ii-flex-col esc-ii-px-3 lg:esc-ii-px-8 lg:esc-ii-pb-6">
                    <Subtitle text={heading} />
                    <div className="esc-tooltip-body" dangerouslySetInnerHTML={{ __html: tooltip.bodyHtml || '' }} />
                </div>
            </div>
        </>
    )
    return (
        <>
            <Modal isActive={active} />
            <button
                type="button"
                className="esc-ii-flex esc-ii-items-center esc-ii-ml-2.5"
                onClick={() => setActive(!active)}
            >
                <Icon.Info width={`18.33`} height={`18.33`} />
                <span className="esc-ii-underline esc-ii-italic esc-ii-ml-1.5 esc-ii-font-montserrat esc-ii-text-[9px]">
                    {unescape(tooltips.triggerLabel, 'all')}
                </span>
            </button>
        </>
    );
}

Field.Quantity = Quantity;
Field.Button = ({ children, type = 'primary' }) => (
    <>
        <button className="esc-ii-bg-black esc-ii-py-4">
            <span className="esc-ii-text-white esc-ii-uppercase">
                {children}
            </span>
        </button>
    </>
);;
export default Field;
